export type LandingNavItem = {
  id: string;
  label: string;
};

export const LANDING_NAV_ITEMS: LandingNavItem[] = [
  { id: 'home', label: 'Home' },
  { id: 'problems', label: 'Problems' },
  { id: 'solutions', label: 'Solutions' },
  { id: 'features', label: 'Features' },
  { id: 'how-it-works', label: 'How it works' }
];

export const LANDING_MORE_NAV_ITEMS: LandingNavItem[] = [
  { id: 'ecosystem', label: 'Ecosystem' },
  { id: 'insight', label: 'Insight' },
  { id: 'faq', label: 'FAQ' }
];

export const ALL_LANDING_NAV_ITEMS: LandingNavItem[] = [...LANDING_NAV_ITEMS, ...LANDING_MORE_NAV_ITEMS];

export const LANDING_SPY_SECTION_IDS = [...ALL_LANDING_NAV_ITEMS.map((item) => item.id), 'ready'];

export const LANDING_NAVBAR_ON_COLOR_SECTION_IDS = ['home', 'how-it-works', 'ready'];

export const LANDING_NAVBAR_LIGHT_TEXT_SECTION_IDS = ['how-it-works', 'ready'];

export const DEFAULT_LANDING_SECTION_ID = LANDING_NAV_ITEMS[0].id;
